import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider, DataTransformationProtocol } from "@tendercuts/http";
import { LocationPing } from "@tendercuts/models";

@Injectable()
export class TripPathService
  extends BaseGetProvider<LocationPing>
  implements DataTransformationProtocol {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof LocationPing {
    return LocationPing;
  }

  get endpoint(): string {
    return this.endpointService.tripPath();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(tripId: string): HttpParams {
    let params: HttpParams = new HttpParams();
    params = params.append("trip_id", tripId);

    return params;
  }
}
